export enum MessageType {
  SOCIAL_NETWORK = 'SOCIAL_NETWORK',
  JOIN = 'JOIN',
  LEAVE = 'LEAVE',
  FORBIDDEN = 'FORBIDDEN',
}
